import { FileText } from "lucide-react";
import { useNavigate } from "react-router";
import CleTable, { type CleTableColumn } from "@cle/components/CleTable";
import { useReportEvidenceByPeriod } from "@/hooks/useEfteruddannelseIndberetning";
import type { ReportEvidenceModel } from "@cle/models/reportEvidence";
import { formatLessons } from "../../../utils/lessonLimits";
import {
  getEvidenceDocumentPath,
  getEvidenceTypeLabel,
} from "@cle/utils/evidenceDocumentType";

type ReportedDocumentsTableProps = {
  periodId?: string | null;
};

const MISSING_VALUE = "-";

const columns: CleTableColumn<ReportEvidenceModel>[] = [
  {
    id: "fileName",
    header: "Dokument",
    title: (document) => document.fileName ?? MISSING_VALUE,
    cell: (document) => (
      <span className="d-inline-flex align-items-center gap-2">
        <FileText size={15} aria-hidden strokeWidth={1.75} />
        {document.fileName}
      </span>
    ),
  },
  {
    id: "type",
    header: "Type",
    cell: (document) => getEvidenceTypeLabel(document.evidenceType),
  },
  {
    id: "lessons",
    header: "Lektioner",
    className: "text-end fw-bold",
    cell: (document) => formatLessons(document.numberOfLessons),
  },
];

const ReportedDocumentsTable = ({ periodId }: ReportedDocumentsTableProps) => {
  const navigate = useNavigate();
  const {
    data: reportEvidence = [],
    isError,
    isLoading,
  } = useReportEvidenceByPeriod(periodId);
  return (
    <CleTable
      columns={columns}
      data={reportEvidence}
      emptyDescription="Når indberettede dokumenter er tilgængelige, vises de her."
      emptyTitle="Ingen dokumenter fundet"
      errorMessage="Dokumenterne kunne ikke indlæses lige nu."
      isError={isError}
      isLoading={isLoading}
      loadingRowCount={4}
      rowAction={{
        onClick: (_documentId, evidence) => {
          const documentPath = getEvidenceDocumentPath(
            evidence.evidenceType,
            evidence.id,
          );

          if (documentPath) {
            void navigate(documentPath);
          }
        },
      }}
    />
  );
};

export default ReportedDocumentsTable;
